import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getGameProviderList } from '../../services'
import {
	GameProviderListResponse,
	GetGameProviderListRequest,
} from '@/modules/game/type'
import { GameQueryKeys } from '@/modules/game/keys'

export default function useQueryGetGameProviderList(
	payload: GetGameProviderListRequest,
	props?: UseBaseQueryOptions<GameProviderListResponse>,
) {
	return useQuery({
		queryKey: [GameQueryKeys.GetGameProviderList, payload],
		queryFn: () => getGameProviderList(payload),
		...props,
	})
}
